import { render, staticRenderFns } from "./web2023051004.vue?vue&type=template&id=11570816&scoped=true&"
import script from "./web2023051004.vue?vue&type=script&lang=js&"
export * from "./web2023051004.vue?vue&type=script&lang=js&"
import style0 from "./web2023051004.vue?vue&type=style&index=0&id=11570816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11570816",
  null
  
)

export default component.exports